import AxiosInstance from '../config/AxiosInstance';

/** One (day, product) line as the API returns it — numerics arrive as strings. */
export interface ProductPerformanceApiRow {
    /** Calendar day in the requested `tz`, as YYYY-MM-DD text. */
    tx_date: string;
    product_id: string;
    SKU: string | null;
    Product: string | null;
    quantity: string;
    refunded_quantity: string;
    net: string;
    tax: string;
    gross: string;
    total_amount: string;
}

export interface ProductPerformanceResponse {
    status: number;
    message: string;
    data: ProductPerformanceApiRow[];
    /** True when the range produced more rows than the API returns (first 5000 by gross). */
    truncated?: boolean;
}

const getProductPerformanceByDate = async (
    companyId: string,
    locationId: string,
    dateFrom: string,
    dateTo: string,
    productId?: string | null,
    tz?: string
) => {
    try {
        const params: Record<string, string> = {
            dateFrom,
            dateTo,
            locationId,
        };
        if (productId) {
            params.productId = productId;
        }
        if (tz) {
            params.tz = tz;
        }
        const { data } = await AxiosInstance.get<ProductPerformanceResponse>(
            '/api/inventory/product-performance/by-date',
            { params }
        );
        return { data };
    } catch (error) {
        throw error;
    }
};

export { getProductPerformanceByDate };
